declare global {
  interface XMLHttpRequest {
    wrappedSetRequestHeader(header: string, value: string): void;
    headers: { [header: string]: string[] };
  }
}

XMLHttpRequest.prototype.wrappedSetRequestHeader =
  XMLHttpRequest.prototype.setRequestHeader;

XMLHttpRequest.prototype.setRequestHeader = function (header, value) {
  this.wrappedSetRequestHeader(header, value);

  if (!this.headers) {
    this.headers = {};
  }

  if (!this.headers[header]) {
    this.headers[header] = [];
  }

  this.headers[header].push(value);
};

export {};
